module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEjSURBVGhD7ZWxakIxFIbPoLOP4VBxElztXgoFHRxcnRRfQCq+SZe+Wre2ODjH1pvAMf7gMfFi5P4/fMvNIed8kOQKw9QU9yEul99FBVrT7NcVaC3gx7IHbXItjRF4HfSPLF+ezwg1fix7dINUKECBTChAgUysAl9vFeF/oAk1fix7dINUGiPAO4CiG6RCAQpkYhUo4hV6H/fcZvx08g0JoLoiBGaj4RH9DQmguiKOEAUoEEU3sPB/MbeTy5cY1RUhgEACiCJeIURjBB7+CFEARTdIhQKPIsBnFEU3SMUqwDuAohukQgEKZHJXgdC8FPxY9qBN7okfy554g++FTN1c2n65lriNtHYr6f71+4z7+xJ74g3qHl7nZy6duL9fYpjbRuQAaKkUN+ZhBwkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assests/furniture.png
// module id = 228
// module chunks = 1